import styled from '@emotion/styled';
import colors from '$variables/colors';
import { spacing, typography } from '$variables/theme';

export const Header = styled.div`
  padding: 40px ${spacing.xLarge} ${spacing.xLarge};
  border-bottom: 1px solid ${colors.grey};
`;

export const Content = styled.div`
  padding: ${spacing.xLarge};
`;

export const Subtitle = styled.div`
  margin-bottom: 12px;
  font-weight: ${typography.fontWeightMedium};
  font-size: 14px;
  color: ${colors.olive};
`;
